import { render } from "./WithdrawalRequestDetailModal.vue?vue&type=template&id=bc2f5ec2"
import script from "./WithdrawalRequestDetailModal.vue?vue&type=script&lang=js"
export * from "./WithdrawalRequestDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__